import { render, staticRenderFns } from "./gradeAdditionsTable.vue?vue&type=template&id=3591cdb8&scoped=true"
import script from "./gradeAdditionsTable.vue?vue&type=script&lang=js"
export * from "./gradeAdditionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3591cdb8",
  null
  
)

export default component.exports